import { render } from "./TitleSetter.vue?vue&type=template&id=3ba61236"
import script from "./TitleSetter.vue?vue&type=script&lang=js"
export * from "./TitleSetter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__